import { Injectable } from '@angular/core';
import {
  Professional,
  ProfessionalParticularService,
  ProfessionalService,
  User,
  UserService,
  WebServiceOptions,
} from '@adeo/ngx-kozikaza-api';
import { Observable, of, throwError } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import {
  ProfessionalCoachingRequest,
} from '@adeo/ngx-kozikaza-api/pro/coaching-request';

@Injectable({
  providedIn: 'root'
  })
export class ProUsersService {

  constructor(
    private readonly professionalService: ProfessionalService,
    private readonly professionalParticularService: ProfessionalParticularService,
    private readonly userService: UserService,
  ) { }

  /*
  * Get User or Professional entity from coachingRequest.owner value
  * */
  getOwnerFromCoachingRequest(coachingRequest: ProfessionalCoachingRequest): Observable<User | Professional> {

    let reach5IdObservable: Observable<string>;
    if ((typeof coachingRequest.customer !== 'string') && 'brand' in coachingRequest.customer) {
      // owner is Professionnal entity => return Professional
      return of(coachingRequest.customer);
    } else if (typeof coachingRequest.customer !== 'string') {
      // owner is Particular entity
      reach5IdObservable = of(coachingRequest.customer.reach5Id);
    } else {
      // owner is Particular id
      reach5IdObservable = this.professionalParticularService.getProfessionalParticular(coachingRequest.customer['@id']).pipe(
        map((user) => user.reach5Id));
    }

    // => return User
    return reach5IdObservable.pipe(
      switchMap((reach5Id) => this.userService.getUserByReach5Id(reach5Id)),
      switchMap((users) => users['hydra:member'][0] ? of(users['hydra:member'][0]) : throwError('reach5Id not in Kzkz API'))
    );

  }

  /*
  * Get Pro UserId (Particular or Professional) from Kozikaza user reach5Id
  *  --> option: createAPIProUserIfNotExist (only if user is not PRO)
  * */
  getAPIProUserIdFromKzkzUser(kzkzUser: User, createAPIProUserIfNotExist = false): Observable<string> {
    if (!kzkzUser) {
      return of(null);
    }
    const ownerIsParticular = !kzkzUser.professionalId;
    const reach5Obj = { reach5Id: kzkzUser.reach5Id, refresh: `${new Date().getTime()}` };
    const webServiceOptions: WebServiceOptions = {
      refresh: true,
      query: new HttpParams({ fromObject: reach5Obj })
    };
    return ownerIsParticular
      ? this.professionalParticularService.getProfessionalParticulars(null, webServiceOptions).pipe(
        switchMap((users) =>
          ((users['hydra:member'][0] && typeof users['hydra:member'][0] !== 'string')
            ? of(users['hydra:member'][0]['@id'])
            : (createAPIProUserIfNotExist)
              ? this.professionalParticularService.postProfessionalParticulars(reach5Obj).pipe(
                switchMap((user) =>
                  ((user && typeof user !== 'string')
                    ? of(user['@id']) : throwError('reach5Id not in pro API (after POST)'))
                )
              )
              : throwError('reach5Id not in pro API'))
        ))
      : of (typeof kzkzUser.professionalId === 'string' ?  kzkzUser.professionalId : kzkzUser.professionalId['@id']);
  }

}
